import React, { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import Input from '../../components/ui/Input';
import { useAuth } from '../../contexts/AuthContext';
import { getApiErrorMessage } from '../../utils/errors';
import { homePathFor } from '../../support/accountFunction';

function Login() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const redirectTo = location.state?.from?.pathname;

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    setIsSubmitting(true);

    try {
      const result = await login(email, password);
      if (result.needsAccountSelection || result.needsWorkspaceCreation) {
        navigate('/select-account', { replace: true });
        return;
      }
      navigate(redirectTo || homePathFor(result.user, { memberships: result.memberships, account: result.account }), {
        replace: true,
      });
    } catch (err) {
      setError(getApiErrorMessage(err, 'E-mail ou senha inválidos.'));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="surface-card p-8 shadow-card-md">
      <div className="text-center mb-8">
        <h1 className="text-2xl font-bold text-content-primary mb-2">Entrar</h1>
        <p className="text-content-muted text-sm">
          Acesse o painel com seu e-mail e senha.
        </p>
      </div>

      <form onSubmit={handleSubmit} className="space-y-5">
        <Input
          id="email"
          label="E-mail"
          type="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="voce@empresa.com"
          required
          autoFocus
        />

        <Input
          id="password"
          label="Senha"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          placeholder="Sua senha"
          required
          error={error}
        />

        <button
          type="submit"
          disabled={isSubmitting}
          className="btn-primary w-full disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isSubmitting ? 'Entrando...' : 'Entrar'}
        </button>
      </form>

      <div className="mt-6 flex flex-col gap-3">
        <Link to="/lead" className="btn-secondary w-full text-center">
          Criar conta
        </Link>
        <Link to="/" className="text-sm text-content-muted hover:text-content-primary text-center transition-colors">
          Voltar para início
        </Link>
      </div>
    </div>
  );
}

export default Login;
